import { getAppCfg } from "../../core/app-cfg";
import { projectListId } from "../../core/code/loader";
import { migrateProjectListEntryToCloud, migrateUserDataToCloud } from "../../core/code/saver";
import { CONSTANTS } from "../../core/constants";
import { cloudProjectId } from "../../core/project/projectid";
import { getDomainCfg } from "../../core/state";
import { setCloudProjectList } from "../cloudstorage/cloud";
import { getUserDataKey } from "./keys";
import { getUserCodeFromLS, getUserCodeFromLSAsync } from "./loader";

export function deleteUserCodeFromLS() {
  if (getAppCfg().view === "launch") {
    return;
  }

  localStorage.removeItem(getUserDataKey());
  //resetCodeEditor();
}

export function cleanLocalProjects() {
  const prefix = getDomainCfg().viewSettings.codeId;
  const toDelete = [];
  for (let i = 0; i < localStorage.length; i++) {
    const item = localStorage.key(i) || "";
    if (item.substring(0,3 + prefix.length) === CONSTANTS.LS_PREFIX + prefix) {
      const projectStorageKey = localStorage.key(i);
      toDelete.push(projectStorageKey);
    }
  }

  toDelete.forEach((projectStorageKey) => localStorage.removeItem(projectStorageKey || ""));
  localStorage.removeItem(projectListId());
}

export async function migrateLocalStorageProjectsToCloud() {
  console.log('Migrating local storage projects to cloud');
  setCloudProjectList({ list : [] });
  const toDelete = [];
  const projectsData = [];
  for (let i = 0; i < localStorage.length; i++) {
    const localStorageKey = localStorage.key(i) || "";
    if (isProjectStorageKeyMatching(localStorageKey)) {
      const projectId = projectIdFromStorageKey(localStorageKey);
      const projectData = await migrateProjectToCloud(projectId);
      projectsData.push(projectData);
      toDelete.push(localStorageKey);
    }
  }

  toDelete.forEach((projectStorageKey) => localStorage.removeItem(projectStorageKey));
}

async function migrateProjectToCloud(projectId : string) {
  const data = await getUserCodeFromLSAsync(projectId)
  const migratedProjectId = await cloudProjectId(projectId);
  await migrateUserDataToCloud(migratedProjectId, data);
  await migrateProjectListEntryToCloud(migratedProjectId, data);
}

function isProjectStorageKeyMatching(projectStorageKey : string) {
  const prefix = getDomainCfg().viewSettings.codeId;
  return projectStorageKey.substring(0,3 + prefix.length) === CONSTANTS.LS_PREFIX + prefix;
}

function projectIdFromStorageKey(projectStorageKey : string) {
  const prefix = getDomainCfg().viewSettings.codeId;
  const start = CONSTANTS.LS_PREFIX.length + prefix.length;
  return projectStorageKey.substring(start, projectStorageKey.length);
}
